import { useIsMutating, useMutation } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { post } from "common/helpers/HTTP";

export interface FileUploadProps {
  accountId: string;
}

async function uploadFileRequest(
  workspaceId: string,
  accountId: string,
  file: Blob,
  filename: string,
  abortSignal?: AbortSignal,
): Promise<{
  file_identifier: string;
  file_input: {
    originalname: string;
    encoding: string;
    mimetype: string;
    size: number;
  };
}> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("file_name", filename);

  return await post(
    `workspaces/${workspaceId}/accounts/${accountId}/conversations/upload-file`,
    formData,
    abortSignal,
  );
}

const MUTATION_KEY = ["uploadFile"];

export default function useFileUpload({ accountId }: FileUploadProps) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { mutateAsync: uploadFile, isPending: isUploading } = useMutation({
    mutationFn: ({
      file,
      filename,
      abortSignal,
    }: {
      file: Blob;
      filename: string;
      abortSignal?: AbortSignal;
    }) =>
      uploadFileRequest(workspaceId, accountId, file, filename, abortSignal),
    mutationKey: MUTATION_KEY,
  });

  //this is used to return a loading state for multiple mutations
  const isUploadingAnyFiles = !!useIsMutating({ mutationKey: MUTATION_KEY });

  return {
    uploadFile,
    isUploading,
    isUploadingAnyFiles,
  };
}
